(function () {
    'use strict';

    angular
        .module('riskModule')
        .directive('assessmentRatings', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                assessment: '=',
                layoutRatio: '=?',
                onlyInitial: '=?',
                onlyFinal: '=?',
                finalAsAvailable: '=?',
                title: '@'
            },
            templateUrl: require('./assessmentRatings.tpl.html'),
            controller: ['$scope', 'commonRiskSelfAssessmentService', function ($scope, service) {
                var naRating = { Color: 'default', Name: 'N/A' };

                $scope.initRatings = function () {
                    return service
                        .getAllCriterias()
                        .then(function (criterias) {
                            $scope.probabilityRatings = _.filter(criterias, { RiskLookupAssessmentTypeName: 'Probability' });
                            $scope.severityRatings = _.filter(criterias, { RiskLookupAssessmentTypeName: 'Severity' });
                            $scope.mitigationRatings = _.filter(criterias, { RiskLookupAssessmentTypeName: 'Mitigation' });
                            $scope.overallRatings = _.filter(criterias, { RiskLookupAssessmentTypeName: 'Overall' });
                        }
                    );
                };

                // Get Probability Rating
                $scope.getProbabilityRating = function () {

                    if (!$scope.assessment) return naRating;

                    var code = $scope.assessment.InitialProbabilityCode || naRating;
                    if ($scope.onlyInitial === true) code = $scope.assessment.InitialProbabilityCode || naRating;
                    else if ($scope.onlyFinal === true) code = $scope.assessment.FinalProbabilityCode || naRating;
                    else if ($scope.finalAsAvailable === true && $scope.assessment.FinalClosing) code = naRating;
                    else if ($scope.finalAsAvailable === true && $scope.assessment.HasFinalAssessorReviewed && $scope.assessment.IsAcknowledged === false) code = naRating;
                    else if ($scope.finalAsAvailable === true) code = $scope.assessment.FinalProbabilityCode || $scope.assessment.InitialProbabilityCode || naRating;

                    if (code === naRating) return code;

                    return _.find($scope.probabilityRatings, { Code: code });
                }

                // Get Severity Rating
                $scope.getSeverityRating = function () {

                    if (!$scope.assessment) return naRating;

                    var code = $scope.assessment.InitialSeverityCode || naRating;
                    if ($scope.onlyInitial === true) code = $scope.assessment.InitialSeverityCode || naRating;
                    else if ($scope.onlyFinal === true) code = $scope.assessment.FinalSeverityCode || naRating;
                    else if ($scope.finalAsAvailable === true && $scope.assessment.FinalClosing) code = naRating;
                    else if ($scope.finalAsAvailable === true && $scope.assessment.HasFinalAssessorReviewed && $scope.assessment.IsAcknowledged === false) code = naRating;
                    else if ($scope.finalAsAvailable === true) code = $scope.assessment.FinalSeverityCode || $scope.assessment.InitialSeverityCode || naRating;

                    if (code === naRating) return code;

                    return _.find($scope.severityRatings, { Code: code });
                }

                // Get Mitigation Rating
                $scope.getMitigationRating = function () {

                    if (!$scope.assessment) return naRating;

                    var code = $scope.assessment.InitialMitigationCode || naRating;
                    if ($scope.onlyInitial === true) code = $scope.assessment.InitialMitigationCode || naRating;
                    else if ($scope.onlyFinal === true) code = $scope.assessment.FinalMitigationCode || naRating;
                    else if ($scope.finalAsAvailable === true && $scope.assessment.FinalClosing) code = naRating;
                    else if ($scope.finalAsAvailable === true && $scope.assessment.HasFinalAssessorReviewed && $scope.assessment.IsAcknowledged === false) code = naRating;
                    else if ($scope.finalAsAvailable === true) code = $scope.assessment.FinalMitigationCode || $scope.assessment.InitialMitigationCode || naRating;

                    if (code === naRating) return code;

                    return _.find($scope.mitigationRatings, { Code: code });
                }

                // Get Overall Rating
                $scope.getOverallRating = function () {

                    if (!$scope.assessment) return naRating;

                    var code = $scope.assessment.InitialOverallCode || naRating;
                    if ($scope.onlyInitial === true) code = $scope.assessment.InitialOverallCode || naRating;
                    else if ($scope.onlyFinal === true) code = $scope.assessment.FinalOverallCode || naRating;
                    else if ($scope.finalAsAvailable === true && $scope.assessment.FinalClosing) code = naRating;
                    else if ($scope.finalAsAvailable === true && $scope.assessment.HasFinalAssessorReviewed && $scope.assessment.IsAcknowledged === false) code = naRating;
                    else if ($scope.finalAsAvailable === true) code = $scope.assessment.FinalOverallCode || $scope.assessment.InitialOverallCode || naRating;

                    if (code === naRating) return code;

                    return _.find($scope.overallRatings, { Code: code });
                }

                // Is In Progress
                $scope.getIsInProgress = function () {
                    if (!$scope.assessment || !$scope.finalAsAvailable) return false;

                    return !$scope.assessment.HasInitialAssessorSubmitted && !$scope.assessment.HasFinalAssessorReviewed;
                }
            }],
            link: function (scope, elem, attrs) {
                
                scope.layoutRatio = scope.layoutRatio ? scope.layoutRatio : {
                    column: 'col-sm-12',
                    yearColumnSize: '3',
                    ratingColumnSize: '9',
                    hideIcon  : false,
                    hideLabels: false
                };

                function updateRatings() {
                    scope.probabilityRating = scope.getProbabilityRating();
                    scope.severityRating = scope.getSeverityRating();
                    scope.mitigationRating = scope.getMitigationRating();
                    scope.overallRating = scope.getOverallRating();
                    scope.isInProgress = scope.getIsInProgress();
                }

                scope.initRatings()
                    .then(function () {
                        updateRatings();
                    });

                scope.$watch('assessment', function (newValue, oldValue) {
                    if (newValue) {
                        updateRatings();
                    }
                });
            }
        }
    }
})();